<template>
  <div class="ide-tree">
    <el-tree
      ref="tree"
      :data="nodes"
      :indent="8"
      node-key="frontId"
      :props="{label: 'name'}"
      :filter-node-method="filter"
      :current-node-key="currentNodeFrontNo"
      :default-expand-keys="openedFolders"
      :highlight-current="true"
      :expand-on-click-node="false"
    >
      <div class="node" slot-scope="{ node, data }">
        <div
          class="node-label__wrap"
          :class="{ 'edited': data.__isEdited }"
          @dblclick="openFile(data)"
          @click="handleNodeClick"
          @contextmenu.prevent="data.__showMenu = true"
        >
          <i v-if="data.type === 'folder'" class="ideicon ide-icon-folder-full"></i>
          <i v-else :class="{ icon: true, [getFileSuffix(data.name)]: true }"></i>
          <span class="node-label">{{data.name}}</span>
        </div>
        <div v-if="data.__showMenu" class="node-menu__wrap">
          <!-- 根目录菜单 -->
          <template v-if="data.frontId === 'root'">
            <ul>
              <li @click.stop="operaFile(null, data)">
                <i class="icon icon-file"></i>新建文件
              </li>
              <li @click.stop="operaFolder(null, data)">
                <i class="icon icon-folder"></i>新建目录
              </li>
              <li @click.stop="$refs.uploadZipDialog.open()" class="seg">
                <i class="icon icon-upload"></i>上传代码包
              </li>
              <li class="seg">
                <i class="icon icon-clear"></i>清空
              </li>
            </ul>
          </template>
          <!-- 目录菜单 -->
          <template v-else-if="data.type === 'folder'">
            <ul>
              <li @click.stop="operaFile(null, data)">
                <i class="icon icon-file"></i>新建模版
              </li>
              <li @click.stop="operaFolder(null, data)">
                <i class="icon icon-folder"></i>新建目录
              </li>
              <li @click.stop="deleteFolder(data)" class="seg">
                <i class="icon icon-trash-white"></i>删除
              </li>
              <li v-if="data.frontNo !== 'root'" @click.stop="operaFolder(data)">
                <i class="icon icon-setting"></i>设置
              </li>
            </ul>
          </template>
          <!-- 文件菜单 -->
          <template v-else-if="data.type === 'file'">
            <ul>
              <li @click.stop="deleteFile(data)" class="seg">
                <i class="icon icon-trash-white"></i>删除
              </li>
              <li v-if="data.frontNo !== 'root'" @click.stop="operaFile(data)">
                <i class="icon icon-setting"></i>设置
              </li>
            </ul>
          </template>
        </div>
      </div>
    </el-tree>
    <OperaFileDialog ref="operaFileDialog" :template-files="templateFiles" :template-id="templateId" @create-success="createFileSuccess"/>
    <OperaFolderDialog ref="operaFolderDialog" @create-success="createFolderSuccess" @edit-success="editFolderSuccess"/>
    <UploadZipDialog ref="uploadZipDialog" @upload-success="uploadZipSuccess"/>
  </div>
</template>

<script>
import OperaFileDialog from './OperaFileDialog'
import utils, { parsePath } from '../utils'
import FileMixin from './FileMixin'
import OperaFolderDialog from './OperaFolderDialog'
import BaseMixin from '../mixins/BaseMixin'
import UploadZipDialog from './UploadZipDialog'
export default {
  name: 'IDETree',
  mixins: [BaseMixin, FileMixin],
  components: { UploadZipDialog, OperaFolderDialog, OperaFileDialog },
  props: {
    // 模版ID
    templateId: {
      required: true
    },
    // 文件列表
    files: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      // 当前操作节点
      currentOperaNode: null,
      // 节点列表
      nodes: [],
      // 模版文件列表
      templateFiles: this.files,
      // 展开的目录
      openedFolders: [],
      // 打开的文件列表
      openedFiles: [],
      // 当前节点
      currentNodeFrontNo: null
    }
  },
  watch: {
    files () {
      this.__toNodes()
    }
  },
  methods: {
    ...utils,
    // 添加文件
    operaFile (file, folder) {
      if (file != null) {
        file.__showMenu = false
      }
      if (folder != null) {
        folder.__showMenu = false
      }
      if (folder == null) {
        folder = this.__searchFolderByPath(this.nodes, file.outputPath)
      }
      this.$refs.operaFileDialog.open(file, folder)
    },
    // 创建文件成功
    createFileSuccess ({ file, folder }) {
      this.__pushFile(file, folder)
    },
    // 添加目录
    operaFolder (folder, parentFolder) {
      if (folder != null) {
        folder.__showMenu = false
      }
      if (parentFolder != null) {
        parentFolder.__showMenu = false
      }
      if (parentFolder == null) {
        const paths = parsePath(folder.path)
        const parentPath = paths.slice(0, paths.length - 1).join('/')
        parentFolder = this.__searchFolderByPath(this.nodes, parentPath)
      }
      this.$refs.operaFolderDialog.open(folder, parentFolder)
    },
    // 创建目录成功
    createFolderSuccess ({ folder, parentFolder }) {
      this.__pushFolder(folder, parentFolder)
    },
    // 修改目录成功
    editFolderSuccess ({ folder }) {
      this.__syncFolderFiles(folder)
    },
    // 上传ZIP成功
    uploadZipSuccess (files) {
      for (const file of files) {
        this.__syncFileInfo(file)
        this.__pushFile(file, null)
      }
    },
    // 文件名称过滤
    filter (value, data) {
      // 已删除的文件
      if (data.id < 0) {
        return false
      }
      // 没有搜索条件
      if (value == null || value === '') {
        return true
      }
      if (data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1) {
        return true
      }
      return false
    },
    // 打开文件
    openFile (file) {
      if (file.type === 'folder') {
        this.__expandFolder(file)
        return
      }
      if (file.type === 'file') {
        const targetFileIndex = this.openedFiles.findIndex(f => f.frontId === file.frontId)
        const targetFile = this.openedFiles[targetFileIndex]
        if (targetFile == null) {
          this.openedFiles.unshift(file)
        } else {
          this.openedFiles.splice(targetFileIndex, 1)
          this.openedFiles.unshift(targetFile)
        }
        this.$emit('open-file', { file, openedFiles: this.openedFiles })
      }
    },
    // 点击节点
    handleNodeClick () {
      this.closeAllMenu()
    },
    // 关闭所有菜单
    closeAllMenu (nodes) {
      if (nodes == null) {
        nodes = this.nodes
      }
      for (const node of nodes) {
        node.__showMenu = false
        if (node.children != null && node.children.length > 0) {
          this.closeAllMenu(node.children)
        }
      }
    },
    // 删除文件
    deleteFile (file) {
      file.__showMenu = false
      this.__confirm(`确认删除${file.name}文件吗？`)
        .then(() => {
          file.id *= -1
          this.$refs.tree.filter()
        })
    },
    // 删除目录
    deleteFolder (folder) {
      folder.__showMenu = false
      // 找到父目录
      const paths = this.parsePath(folder.path)
      const folderIndex = paths.length - 1
      const parentPath = paths.splice(0, paths.length - 1).join('/')
      const parentFolder = this.__searchFolderByPath(this.nodes, parentPath)
      // 找到当前目录坐标
      let index = -1
      for (let i = 0; i < parentFolder.children.length; i++) {
        const child = parentFolder.children[i]
        if (child.type === 'folder' && child.frontId === folder.frontId) {
          index = i
          break
        }
      }
      // 如果当前目录是空的，则直接删除
      if (folder.children.length === 0) {
        parentFolder.children.splice(index, 1)
        return
      }
      // 删除
      this.__deleteFolderByIndex(folder.children, folderIndex)
      parentFolder.children.splice(index, 1)
      parentFolder.children.push.apply(parentFolder.children, folder.children)
    },
    // 获取所有模版文件
    getTemplateFiles () {
      return this.templateFiles
    },
    // 根据索引删除目录
    __deleteFolderByIndex (nodes, index) {
      for (const node of nodes) {
        if (node.type === 'folder') {
          const paths = this.parsePath(node.path)
          paths.splice(index, 1)
          node.path = paths.join('/')
          if (node.children.length > 0) {
            this.__deleteFolderByIndex(node.children, index)
          }
        }
        if (node.type === 'file') {
          const paths = this.parsePath(node.outputPath)
          paths.splice(index, 1)
          node.outputPath = paths.join('/')
          node.__isEdited = true
        }
      }
    },
    // 转为节点
    __toNodes () {
      for (const file of this.files) {
        this.__pushFile(file)
      }
    },
    // 展开目标文件目录
    __expandFolder (target, callback) {
      const nodeKeys = []
      let parent = target
      if (target.type === 'folder') {
        nodeKeys.push(parent.frontId)
      }
      while ((parent = parent.parentNode)) {
        nodeKeys.push(parent.frontId)
      }
      setTimeout(() => {
        this.__expandNode(this.$refs.tree.store.nodesMap, nodeKeys)
        callback && callback()
      }, 10)
    },
    // 获取nodeMap中的节点对象
    __expandNode (nodeMaps, nodeKeys) {
      for (const nodeKey in nodeMaps) {
        const node = nodeMaps[nodeKey]
        if (nodeKeys.findIndex(key => nodeKey === key) > -1) {
          node.expanded = true
        }
      }
    }
  },
  mounted () {
    document.body.addEventListener('click', () => {
      this.closeAllMenu()
    })
  }
}
</script>

<style scoped lang="scss">
@import "../variables";
$node-height: 20px;
.ide-tree {
  min-height: 100%;
  background-color: $menu-background;
  /deep/ .el-tree {
    color: #fff;
    background-color: $menu-background;
    // 选中节点
    &.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
      background-color: $menu-node-selected-background;
    }
    // 节点悬浮
    .el-tree-node__content:hover {
      background-color: $menu-background;
    }
    // 节点聚焦
    .el-tree-node:focus > .el-tree-node__content {
      background-color: $menu-background;
    }
    // 节点
    .el-tree-node__content {
      height: $node-height;
      display: flex;
      user-select: none;
    }
    // 子节点
    .el-tree-node__children {
      overflow: visible;
    }
    .node {
      flex: 1;
      position: relative;
      // 节点名称
      .node-label__wrap {
        .icon {
          display: inline-block;
          width: 14px;
          height: 14px;
          vertical-align: middle;
          margin-right: 3px;
        }
        .ideicon {
          margin-right: 3px;
        }
        .node-label {
          font-size: 14px;
          line-height: $node-height;
        }
        &.edited {
          color: $primary-color;
        }
      }
      // 节点菜单
      .node-menu__wrap {
        position: absolute;
        z-index: 999;
        right: 0;
        background: $code-space-background;
        & > ul {
          li {
            font-size: 12px;
            padding: 5px 15px;
            border-bottom: 1px solid $code-space-background + 10;
            &:hover {
              background-color: $code-space-background + 10;
            }
          }
        }
      }
    }
  }
}
</style>
